export const DuckbillDirectoryBanner =
  'https://ik.imagekit.io/duckbill/prod/Task/duckbill-directory-banner-2.png?updatedAt=1730028346065';
